
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexniP2JL0ursREcwmfC_CyKWoTP8u9djqnIwo6uSnwo58Meta } from "/tmp/build_db7b5d36/pages/app/me/index.vue?macro=true";
import { default as mePeSvKuvIyO1tDKdwo_45z56QBewrHVBiDbj5aeeDU18fcMeta } from "/tmp/build_db7b5d36/pages/app/me.vue?macro=true";
import { default as map38zfKr_BcgbeQkLZimoYL1Mhv0mRmHxwXYlinIP_dDgMeta } from "/tmp/build_db7b5d36/pages/app/map.vue?macro=true";
import { default as postY6kSBCp8pDlzrBiLnWMFEBoX_guS1c5zD_T_r4KDKjoMeta } from "/tmp/build_db7b5d36/pages/app/feed/post.vue?macro=true";
import { default as indexQ_45CqijhiE_45tP3YSg7bfEijbF007xMYVu9dCmv2eY740Meta } from "/tmp/build_db7b5d36/pages/app/feed/index.vue?macro=true";
import { default as _91type_93uEK9JhIXj_ZMtX_CXi_UXwP2hXKwXnGC3F5Z_45CWQ_451gMeta } from "/tmp/build_db7b5d36/pages/app/feed/[type].vue?macro=true";
import { default as feedc471H4D07mhVSX3DWHiqPh3H_45_ihzjFAAwRi6D7YIB0Meta } from "/tmp/build_db7b5d36/pages/app/feed.vue?macro=true";
import { default as indexgDsnUCzUdXtSzNqrkivdZQs4_45_8JrUbJS4hozXVsBdwMeta } from "/tmp/build_db7b5d36/pages/app/index.vue?macro=true";
import { default as eulaOZjdU9v_rgHhCH8_FVRyQ4la7Do8sYTnYRcb4MT599AMeta } from "/tmp/build_db7b5d36/pages/main/eula.vue?macro=true";
import { default as indexDKsX2TlyjBROf8M8NDQAKi3Zy4ba0reIH_45JWT8XvfzgMeta } from "/tmp/build_db7b5d36/pages/app/groups/index.vue?macro=true";
import { default as editq_y4DyX9s71OG2_TGsV2NgG8Yo_Wp6EVbbJzhSxTiQAMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutNcgAU3n4ZiYBw6OYyzQykQsZmTLAgMtxHw15Qy8VKfgMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/about.vue?macro=true";
import { default as index3rShhycT2GM1aE_IvyeLD1z4cBpoLTf2j66TulKo5pwMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsvzXxQPCIGVK0Ta92qmxjmhvxAgAMUJLsJt_SZZJN_454YMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersKmLnrmx3dvWi8rPzbJeCT0BEmP35uRSdyi27KyNcL_sMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsjq07BgY1ffW7mCPiWJ5piMecd7i5jZpxmc27aLA3EKEMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_93n1REfu12Bl00TMLIEFqrD7BtLT5HrgE2et4XfSQJOvcMeta } from "/tmp/build_db7b5d36/pages/app/groups/[slug].vue?macro=true";
import { default as createB6H7d_4Ei3FYNTuNysYIzbDv1OZWAFdMyJ2ySVuzxXcMeta } from "/tmp/build_db7b5d36/pages/app/groups/create.vue?macro=true";
import { default as groupsz1fxe9pmN8Wf8yJyQlCswq7UgyDAF9JliSXEUJOtjuMMeta } from "/tmp/build_db7b5d36/pages/app/groups.vue?macro=true";
import { default as index81YBz_45leUDyiWgcO1p7S0rgQxrW6J4PtOssp2d474q8Meta } from "/tmp/build_db7b5d36/pages/app/params/index.vue?macro=true";
import { default as accountHZ3GjXRRNBJYoEk7TcIdZh95MHvcMaqwbZmQMe2CSCoMeta } from "/tmp/build_db7b5d36/pages/app/params/account.vue?macro=true";
import { default as transactionswtBJJ68UhoAhGfpr2ekiyoZM4fuoKCDfjz2PkPEV3HwMeta } from "/tmp/build_db7b5d36/pages/app/params/transactions.vue?macro=true";
import { default as paramspQiVhHwDYyYUumBB8AEuuzGczUnMyqCwolGdTaRYxq8Meta } from "/tmp/build_db7b5d36/pages/app/params.vue?macro=true";
import { default as indexFCraPuvbQmq3l4nm_45_gqma19aupfIskOmBO3QaPLkXEMeta } from "/tmp/build_db7b5d36/pages/main/index.vue?macro=true";
import { default as press8GdlCAZgSdPOWwSA_sybWL8kr_45C5TaIKM_GzyVp4MVIMeta } from "/tmp/build_db7b5d36/pages/main/press.vue?macro=true";
import { default as codesahiM9eErWb7Yz1_NZNTxIkVND3RvVe_HxI4Ogv_45kmXEMeta } from "/tmp/build_db7b5d36/pages/admin/codes.vue?macro=true";
import { default as indexujE29bG8YMdyuygZVOzY4pPW_z0gFBpXT2Ebw1_45svAAMeta } from "/tmp/build_db7b5d36/pages/admin/index.vue?macro=true";
import { default as pagesVYFrJj9dczEIjPbkIH0Asp5SX6jtDTKojfPR40elPAYMeta } from "/tmp/build_db7b5d36/pages/admin/pages.vue?macro=true";
import { default as indexWrfhzFL99jEY49yb4xC2CMTeCqPoR0In85EndbAUWgwMeta } from "/tmp/build_db7b5d36/pages/app/hangout/index.vue?macro=true";
import { default as agendaxvrnjT2Ff_YtQT6PTSoqTjsDIrjzuAdZRdSLRgX9J0YMeta } from "/tmp/build_db7b5d36/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupsz_LRnLqcIxLEBjxlBoLqcmMGLUaH6KQBrR_59IaCpekMeta } from "/tmp/build_db7b5d36/pages/app/hangout/meetups.vue?macro=true";
import { default as organizeweCowzJxnRmktx0SR8CxYmD3i3aRYwAoxEwgnGb_45bQAMeta } from "/tmp/build_db7b5d36/pages/app/hangout/organize.vue?macro=true";
import { default as hangouthRgOXTwRocXZBbl23jVPRquFt9ZnXelG_t9GGmgAJiYMeta } from "/tmp/build_db7b5d36/pages/app/hangout.vue?macro=true";
import { default as charteLjwRfOHniFkMZ5CYXwx7zhenJKqL8X_45ASPTtasuA798Meta } from "/tmp/build_db7b5d36/pages/main/charte.vue?macro=true";
import { default as franceJlhL9xpR5gBgkz_45n5_45zDN7hRLRVPlbuCcl4CCLfXEpcMeta } from "/tmp/build_db7b5d36/pages/main/france.vue?macro=true";
import { default as places1DanaGHU61sbRE_87mNXwNYyqE4OIomBL7tafbZFgKQMeta } from "/tmp/build_db7b5d36/pages/admin/places.vue?macro=true";
import { default as themesyVy_cuk4agry_Sehg1XceA_IJuCHtVeFh0hc5q2r9bAMeta } from "/tmp/build_db7b5d36/pages/admin/themes.vue?macro=true";
import { default as index4W_45wm2etNrd9C_MjtafmjJHGFQedViUmYKGBxag5U3IMeta } from "/tmp/build_db7b5d36/pages/app/insiders/index.vue?macro=true";
import { default as suggestionsE8weUxBr_456kRmsTNfl2jhgQXQWJrkbjfAcgIBsD1mnYMeta } from "/tmp/build_db7b5d36/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersMl1lP13GrlJY5h37Azt6oYvKBa97_45vPzqYDRH0517KUMeta } from "/tmp/build_db7b5d36/pages/app/insiders.vue?macro=true";
import { default as messagestKB9ZpULJZ8bSxQFXWHBcM6CfIlGjm_BZCizljVjEPYMeta } from "/tmp/build_db7b5d36/pages/app/messages.vue?macro=true";
import { default as privacysrc_45JpTeQcm0pJIkCc_45Lm8_YMs1m3mABXH3fSZu9vbMMeta } from "/tmp/build_db7b5d36/pages/main/privacy.vue?macro=true";
import { default as trainerElBYts1LZVew44kst04nMkDtGwFAZkhk6d6l1FHV3U0Meta } from "/tmp/build_db7b5d36/pages/admin/trainer.vue?macro=true";
import { default as indexkTXHQX3hA8sXJiRIbGWd1D9T_45Hz1k_45nyQGKT3aXdjqEMeta } from "/tmp/build_db7b5d36/pages/app/community/index.vue?macro=true";
import { default as searchGRJhaxICBWF07ZbwDsUU_45QKcXbekFnITe_1jDFxvbxEMeta } from "/tmp/build_db7b5d36/pages/app/community/search.vue?macro=true";
import { default as bestiesWqZP3m8Svqi5wZyQ9S6_45qVopO3u_45E2juP1xV9MoQJ1kMeta } from "/tmp/build_db7b5d36/pages/app/community/besties.vue?macro=true";
import { default as indexgJXsiWllNaVVH2nscGZVJqqEZiv0_XpqnjOF_452td9vcMeta } from "/tmp/build_db7b5d36/pages/app/community/[type]/index.vue?macro=true";
import { default as communityJ4kbAQW_Q7YK5ao3vUhgFIhGSuODnTGtTA2zSQpsCxgMeta } from "/tmp/build_db7b5d36/pages/app/community.vue?macro=true";
import { default as indexfmJeL79a4QShNmxGSuKedlWZfnGng99NDp_45qmRAqhIsMeta } from "/tmp/build_db7b5d36/pages/app/auth/index.vue?macro=true";
import { default as aboutEHjah9iwUQkjcOgGyK2rPqcvCKLY9yOykD9hmeIpAqoMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/about.vue?macro=true";
import { default as emailghQs4X_450xgcsg1jTUqOsrvmyZPve_45QZcxOgIwqwnLHkMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/email.vue?macro=true";
import { default as goalsgy_45Unl8QkjDz34fFQVaAcs0htS4F86uhlJOh3OV0dkcMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/goals.vue?macro=true";
import { default as indexOW8IKelzveS1caUs8z4Yco5Av4Dbhv_jei26zVTrJvoMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/index.vue?macro=true";
import { default as phonenjR_N4ZNYPv8h9VATGQPrx79yZDV9jq86_451Ldbv9m9QMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsEI3UsI3zIF1iuZugnWjGUhDXa2aUqXmg4Nn2WMKwqFYMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/groups.vue?macro=true";
import { default as searchvmoG1ikTviVTW_W9Szc70FkFqwcSx8XHXGZpbY9nR44Meta } from "/tmp/build_db7b5d36/pages/app/onboarding/search.vue?macro=true";
import { default as charterjfaWJwkVHCeyIWSqt6Ckab0tmSwEJZDyFNU7Ql0QmRMMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingDCkprwTClT_iW__DMxk0r_45IeGtfgrw7DYjHabR7mwtYMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/loading.vue?macro=true";
import { default as profile62w_45XW_45cw1zohe_45qwYBthP9q5ktgxxobnQqH8BTW4AcMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/profile.vue?macro=true";
import { default as identityEaPRInwaiX2o7AAmPWupOZtWlLJolZxLiHMMi8KiQ9gMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/identity.vue?macro=true";
import { default as profilesMpi_45TsFDXlnuVEKauXnbzBFPInfsuWr6WZbzUOfKcOQMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/profiles.vue?macro=true";
import { default as membership8I_qI0BE6KLhBW3P8c5ExOFDyA_GeOx8DX_459EingqYEMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsbmK0ENtrRNy8LAaan6GNxvVDQSeVyd3tJPhIgTkaqccMeta } from "/tmp/build_db7b5d36/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboarding1AhKy3UVji_9WWd_45chIjQMonf3Zl40Jm51aWHQeecWAMeta } from "/tmp/build_db7b5d36/pages/app/onboarding.vue?macro=true";
import { default as investors5gCrYhzMty0xjn50_45bCLQCXlfIgdmR2ivUHNfHoktLAMeta } from "/tmp/build_db7b5d36/pages/main/investors.vue?macro=true";
import { default as _91id_93yB5LzWYvFVZRbzgZfYhdjE1AEDKMdhhl1XtEr_45EEkCYMeta } from "/tmp/build_db7b5d36/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastAtQ7RW7Z3WjaHm8B_45v7VjtFWN1rIDG8FhDuu2H2AoawMeta } from "/tmp/build_db7b5d36/pages/admin/broadcast.vue?macro=true";
import { default as delete9hLbguPReDS8Puu_qkxfaT5qlWZ1if4VKjFRoUnvQu4Meta } from "/tmp/build_db7b5d36/pages/app/auth/delete.vue?macro=true";
import { default as logoutb5_45SEx5oiAwl6uFUF39MRm4XHF9uaUeQu62wo12usLQMeta } from "/tmp/build_db7b5d36/pages/app/auth/logout.vue?macro=true";
import { default as listEmIKqlCyrnyffLC8EwfZ5pOR7MuwzKCBlHTK8n0bMi0Meta } from "/tmp/build_db7b5d36/pages/app/places/list.vue?macro=true";
import { default as index8Qf1OdBbBJTHTSxbyS9zwsVnnojsA_457lUS7kwhzW9V8Meta } from "/tmp/build_db7b5d36/pages/app/story/index.vue?macro=true";
import { default as indexxLeQMOCryoF88qQQc6n5fLjlMeXBqpsBr_45db5MX__45nsMeta } from "/tmp/build_db7b5d36/pages/backstage/index.vue?macro=true";
import { default as indexIkqgzXWaXKRYvR38OfvpSPFUUD6W9qaxjqLeArETL70Meta } from "/tmp/build_db7b5d36/pages/main/auth/index.vue?macro=true";
import { default as indexnLNyhhto64VwlU3Q_Oy9HuxnVopdfn3VKCGTCJNfGegMeta } from "/tmp/build_db7b5d36/pages/main/blog/index.vue?macro=true";
import { default as indexHV4faNTgksUK559rgBbsHa78c02yfSTts40Ca0e2kRoMeta } from "/tmp/build_db7b5d36/pages/admin/auth/index.vue?macro=true";
import { default as indexhdG4h_45GNA6b2514modc5HobbgaL51ateIYSgc8KiBfEMeta } from "/tmp/build_db7b5d36/pages/admin/blog/index.vue?macro=true";
import { default as deleteq2q4o6mMGmi4WrICAefBjo33LKG_ivmx4hLSOIQUOy4Meta } from "/tmp/build_db7b5d36/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_931ftclG9J22T_Xup2UXbS7O3RWTd0lEaZsYZMUAghIxIMeta } from "/tmp/build_db7b5d36/pages/main/blog/[slug].vue?macro=true";
import { default as index1Cdo3DBGZNMoe3pS2TyqQcHJ8UGUrry_YRYs4Y8uqLQMeta } from "/tmp/build_db7b5d36/pages/main/event/index.vue?macro=true";
import { default as _91token_93scd0V1o7ftW1l3A1GiDi09M4tKLsvT7_Jl592h_SQ8IMeta } from "/tmp/build_db7b5d36/pages/payments/[token].vue?macro=true";
import { default as edit96BhRl1ERV2K2F1rjBl11fA0FS6YOOfLDnXHPw7KrW0Meta } from "/tmp/build_db7b5d36/pages/app/events/[slug]/edit.vue?macro=true";
import { default as index1KEG9iZT7l_q_45DwwRmUjLjrB7VxCPLIR3IAH6MaqbecMeta } from "/tmp/build_db7b5d36/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93p6VsqgpFQXo9yvL_v6bBJKZAZrGPpvYLs_45y_wFknY3QMeta } from "/tmp/build_db7b5d36/pages/app/events/[slug].vue?macro=true";
import { default as createq_45f3c_mxVT_u7VX0NJLVFJDvgRCfgFP3F3kP2jlnDPUMeta } from "/tmp/build_db7b5d36/pages/app/events/create.vue?macro=true";
import { default as listWVhgPJaAOi9622DMsyi_GGN1YroR8hDCW94m1oniMsgMeta } from "/tmp/build_db7b5d36/pages/app/partners/list.vue?macro=true";
import { default as _91slug_93ZRu0Ptt7EqX_mAIPfPV04iNm7n_45tqt5L5wBKFIaRH9EMeta } from "/tmp/build_db7b5d36/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_9333MCXBiLd4JGcsHjkzMf9TudxaozTobJN2xVOg5aFwEMeta } from "/tmp/build_db7b5d36/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93tSMKt4vJLIX3ozxL0ifeegAw8glyNNeNeUhGpNKvltQMeta } from "/tmp/build_db7b5d36/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93MQXkxqzfddEiiMIG60seP7pFU49z_oKjtF0rlHmdv2AMeta } from "/tmp/build_db7b5d36/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93LGiOyvF4yGmBRKU4DNK9kGvTIQpHbPBVlUWsWXr6W28Meta } from "/tmp/build_db7b5d36/pages/main/invite/[slug].vue?macro=true";
import { default as organizations_45Bu1pIul6Ev_1NApJBc8e0omqRnoFg8vIPJL1PwqgBcMeta } from "/tmp/build_db7b5d36/pages/admin/organizations.vue?macro=true";
import { default as indexXb4jOOtObR6N3H0M_5E_IHYPyMTkJP8JgZPe10t86HIMeta } from "/tmp/build_db7b5d36/pages/admin/reports/index.vue?macro=true";
import { default as eventsIekBKDiv_45x2LvQBb3lilvg5_d_Sc_QZ_zHqDptJuBEQMeta } from "/tmp/build_db7b5d36/pages/admin/reports/events.vue?macro=true";
import { default as preferencesFvOZPPs59p0IpyX_45zxfzDCa_Uuj0XNuZKC5iW2NYKmgMeta } from "/tmp/build_db7b5d36/pages/app/auth/preferences.vue?macro=true";
import { default as login20fRSwIZ5GupuHPtlQhBFyh4VQNI0YtPaPs41BxJKukMeta } from "/tmp/build_db7b5d36/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93WzJMpMANVHHmC8nPKVpXsMgayQl2XqMXQBz_45bX7dmxQMeta } from "/tmp/build_db7b5d36/pages/app/conversation/[id].vue?macro=true";
import { default as logoutscbF6EevfwDEN_F16vpE_rpqQ_CEySY_45QhD_45GiKamCkMeta } from "/tmp/build_db7b5d36/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencesExpAm4j8xTLaCJE_45RzpPyM6f02UULJcuBg3iKD5Oi_0Meta } from "/tmp/build_db7b5d36/pages/main/auth/preferences.vue?macro=true";
import { default as list9yPBa3Z_45y7SgRufsAWkmBeW_45eUNXUH3yqoHqoxkasl4Meta } from "/tmp/build_db7b5d36/pages/app/organizations/list.vue?macro=true";
import { default as _91token_934pEi2vv7G_45ZRm0EpdNsw0_8zvjC55lZeFnNOJNCYbu8Meta } from "/tmp/build_db7b5d36/pages/app/auth/verify/[token].vue?macro=true";
import { default as registerhoZxitNhnlLqGAEBOkgmBE1wCy8rmB_454ACergP2VKF8Meta } from "/tmp/build_db7b5d36/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_936Xyr4IyB6PKJ8Jl8H_DJbF_45ZNqbZ0UB8iNFfQLrzhYMMeta } from "/tmp/build_db7b5d36/pages/backstage/invite/[code].vue?macro=true";
import { default as discordhBL6MvMnuMPj4ohkWYEuUaQjpNjS4TbUR07kLczlrboMeta } from "/tmp/build_db7b5d36/pages/app/integrations/discord.vue?macro=true";
import { default as indexcYZ_45mlXosbh6LZ92DyzV88dsk8T0m8gGhj4JTgdVHL4Meta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentes02Lubxildw_45D_45L4E2Rsmf6lWhqh91vfroYQcmqxSu_45IMeta } from "/tmp/build_db7b5d36/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authNQVPY9dKTtnPqK3loGKlTnhlFIVe6voYqjNEQJ4G0L4Meta } from "/tmp/build_db7b5d36/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribeLGQu9ruRD04vSPEsTgrQ99UgfykVEROMf0vClUw69pMMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexNYxVfIwExDEJIqdCJUpNNKj83etVgRJ8d6hLhM_45w0IoMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexW3mdERJQzkmTpi29kB1vk3kvwAdQMG3bGeNGWKQpMTgMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexwC6FnRwc_7Bp6JH_RXy5trP1HILlnR9wsOjfFEZOpNkMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailskTmyqUhBwCFAMD_45Rtk9_F_45O9ZaV0_w3WYMvAUwfqm1gMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedSFc01Qk0xUJyfj5qlGUVsPRwqam84lTVwb1e_45YsO9MkMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendees8vtAy6qXaw9xdaA0Jq19f38irICBlOIyoVsaVyybP4oMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as edit1XOGstdSUSGeFqtQrB_oEbqfRFNIFXvsrOwyyHTKfXIMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexoL64mHSmX7OplBi2TB7dh2H6lzUG4lBpDSG7FzDlsHAMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesu_45WHKaw_jNil9wtq4iZYH5oBfAfetSCNoTJwjRgyIjQMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93Ja_45NkKM67y8_459BRQMVpd4sXSHyRcp_452oloztd83nVQwMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as create9Ds_45ZPRMt5Y5hWbGAXC9rNzpIUbm54z6rzn3Vnlr8kUMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as indexA07E8HxW8SGqPJbDDqe2Jkj9PIOdRNSvbMjR6t8NQVwMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexJYM_45pv8g1CdrftAXX8_45OgMt17HiUfKTZiicWgGbLAHUMeta } from "/tmp/build_db7b5d36/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stub4YlwUqQIT3ervUEL_s1LQYXSRQdGcU1ZFN9EY4jE0T0Meta } from "/tmp/build_db7b5d36/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub4YlwUqQIT3ervUEL_s1LQYXSRQdGcU1ZFN9EY4jE0T0 } from "/tmp/build_db7b5d36/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: mePeSvKuvIyO1tDKdwo_45z56QBewrHVBiDbj5aeeDU18fcMeta?.name,
    path: "/app/me",
    meta: mePeSvKuvIyO1tDKdwo_45z56QBewrHVBiDbj5aeeDU18fcMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(map38zfKr_BcgbeQkLZimoYL1Mhv0mRmHxwXYlinIP_dDgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/map.vue")
  },
  {
    name: feedc471H4D07mhVSX3DWHiqPh3H_45_ihzjFAAwRi6D7YIB0Meta?.name,
    path: "/app/feed",
    meta: { ...(feedc471H4D07mhVSX3DWHiqPh3H_45_ihzjFAAwRi6D7YIB0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postY6kSBCp8pDlzrBiLnWMFEBoX_guS1c5zD_T_r4KDKjoMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexQ_45CqijhiE_45tP3YSg7bfEijbF007xMYVu9dCmv2eY740Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93uEK9JhIXj_ZMtX_CXi_UXwP2hXKwXnGC3F5Z_45CWQ_451gMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(indexgDsnUCzUdXtSzNqrkivdZQs4_45_8JrUbJS4hozXVsBdwMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaOZjdU9v_rgHhCH8_FVRyQ4la7Do8sYTnYRcb4MT599AMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/eula.vue")
  },
  {
    name: groupsz1fxe9pmN8Wf8yJyQlCswq7UgyDAF9JliSXEUJOtjuMMeta?.name,
    path: "/app/groups",
    meta: { ...(groupsz1fxe9pmN8Wf8yJyQlCswq7UgyDAF9JliSXEUJOtjuMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/index.vue")
  },
  {
    name: _91slug_93n1REfu12Bl00TMLIEFqrD7BtLT5HrgE2et4XfSQJOvcMeta?.name,
    path: ":slug()",
    meta: _91slug_93n1REfu12Bl00TMLIEFqrD7BtLT5HrgE2et4XfSQJOvcMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createB6H7d_4Ei3FYNTuNysYIzbDv1OZWAFdMyJ2ySVuzxXcMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramspQiVhHwDYyYUumBB8AEuuzGczUnMyqCwolGdTaRYxq8Meta?.name,
    path: "/app/params",
    meta: { ...(paramspQiVhHwDYyYUumBB8AEuuzGczUnMyqCwolGdTaRYxq8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(index81YBz_45leUDyiWgcO1p7S0rgQxrW6J4PtOssp2d474q8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountHZ3GjXRRNBJYoEk7TcIdZh95MHvcMaqwbZmQMe2CSCoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionswtBJJ68UhoAhGfpr2ekiyoZM4fuoKCDfjz2PkPEV3HwMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexFCraPuvbQmq3l4nm_45_gqma19aupfIskOmBO3QaPLkXEMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: press8GdlCAZgSdPOWwSA_sybWL8kr_45C5TaIKM_GzyVp4MVIMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesahiM9eErWb7Yz1_NZNTxIkVND3RvVe_HxI4Ogv_45kmXEMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexujE29bG8YMdyuygZVOzY4pPW_z0gFBpXT2Ebw1_45svAAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/index.vue")
  },
  {
    name: "admin-pages",
    path: "/admin/pages",
    meta: { ...(pagesVYFrJj9dczEIjPbkIH0Asp5SX6jtDTKojfPR40elPAYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/pages.vue")
  },
  {
    name: hangouthRgOXTwRocXZBbl23jVPRquFt9ZnXelG_t9GGmgAJiYMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangouthRgOXTwRocXZBbl23jVPRquFt9ZnXelG_t9GGmgAJiYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexWrfhzFL99jEY49yb4xC2CMTeCqPoR0In85EndbAUWgwMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaxvrnjT2Ff_YtQT6PTSoqTjsDIrjzuAdZRdSLRgX9J0YMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupsz_LRnLqcIxLEBjxlBoLqcmMGLUaH6KQBrR_59IaCpekMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizeweCowzJxnRmktx0SR8CxYmD3i3aRYwAoxEwgnGb_45bQAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charteLjwRfOHniFkMZ5CYXwx7zhenJKqL8X_45ASPTtasuA798Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: franceJlhL9xpR5gBgkz_45n5_45zDN7hRLRVPlbuCcl4CCLfXEpcMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/france.vue")
  },
  {
    name: "admin-places",
    path: "/admin/places",
    meta: { ...(places1DanaGHU61sbRE_87mNXwNYyqE4OIomBL7tafbZFgKQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/places.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesyVy_cuk4agry_Sehg1XceA_IJuCHtVeFh0hc5q2r9bAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/themes.vue")
  },
  {
    name: insidersMl1lP13GrlJY5h37Azt6oYvKBa97_45vPzqYDRH0517KUMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersMl1lP13GrlJY5h37Azt6oYvKBa97_45vPzqYDRH0517KUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionsE8weUxBr_456kRmsTNfl2jhgQXQWJrkbjfAcgIBsD1mnYMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messagestKB9ZpULJZ8bSxQFXWHBcM6CfIlGjm_BZCizljVjEPYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacysrc_45JpTeQcm0pJIkCc_45Lm8_YMs1m3mABXH3fSZu9vbMMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerElBYts1LZVew44kst04nMkDtGwFAZkhk6d6l1FHV3U0Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/trainer.vue")
  },
  {
    name: communityJ4kbAQW_Q7YK5ao3vUhgFIhGSuODnTGtTA2zSQpsCxgMeta?.name,
    path: "/app/community",
    meta: { ...(communityJ4kbAQW_Q7YK5ao3vUhgFIhGSuODnTGtTA2zSQpsCxgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexkTXHQX3hA8sXJiRIbGWd1D9T_45Hz1k_45nyQGKT3aXdjqEMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchGRJhaxICBWF07ZbwDsUU_45QKcXbekFnITe_1jDFxvbxEMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    meta: { ...(bestiesWqZP3m8Svqi5wZyQ9S6_45qVopO3u_45E2juP1xV9MoQJ1kMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexgJXsiWllNaVVH2nscGZVJqqEZiv0_XpqnjOF_452td9vcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexfmJeL79a4QShNmxGSuKedlWZfnGng99NDp_45qmRAqhIsMeta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/auth/index.vue")
  },
  {
    name: onboarding1AhKy3UVji_9WWd_45chIjQMonf3Zl40Jm51aWHQeecWAMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboarding1AhKy3UVji_9WWd_45chIjQMonf3Zl40Jm51aWHQeecWAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexOW8IKelzveS1caUs8z4Yco5Av4Dbhv_jei26zVTrJvoMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_db7b5d36/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investors5gCrYhzMty0xjn50_45bCLQCXlfIgdmR2ivUHNfHoktLAMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93yB5LzWYvFVZRbzgZfYhdjE1AEDKMdhhl1XtEr_45EEkCYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastAtQ7RW7Z3WjaHm8B_45v7VjtFWN1rIDG8FhDuu2H2AoawMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: delete9hLbguPReDS8Puu_qkxfaT5qlWZ1if4VKjFRoUnvQu4Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutb5_45SEx5oiAwl6uFUF39MRm4XHF9uaUeQu62wo12usLQMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/auth/logout.vue")
  },
  {
    name: "app-places-list",
    path: "/app/places/list",
    meta: { ...(listEmIKqlCyrnyffLC8EwfZ5pOR7MuwzKCBlHTK8n0bMi0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/places/list.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(index8Qf1OdBbBJTHTSxbyS9zwsVnnojsA_457lUS7kwhzW9V8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexxLeQMOCryoF88qQQc6n5fLjlMeXBqpsBr_45db5MX__45nsMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_db7b5d36/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: indexnLNyhhto64VwlU3Q_Oy9HuxnVopdfn3VKCGTCJNfGegMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexHV4faNTgksUK559rgBbsHa78c02yfSTts40Ca0e2kRoMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexhdG4h_45GNA6b2514modc5HobbgaL51ateIYSgc8KiBfEMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_db7b5d36/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_931ftclG9J22T_Xup2UXbS7O3RWTd0lEaZsYZMUAghIxIMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: index1Cdo3DBGZNMoe3pS2TyqQcHJ8UGUrry_YRYs4Y8uqLQMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93scd0V1o7ftW1l3A1GiDi09M4tKLsvT7_Jl592h_SQ8IMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/payments/[token].vue")
  },
  {
    name: _91slug_93p6VsqgpFQXo9yvL_v6bBJKZAZrGPpvYLs_45y_wFknY3QMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93p6VsqgpFQXo9yvL_v6bBJKZAZrGPpvYLs_45y_wFknY3QMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: edit96BhRl1ERV2K2F1rjBl11fA0FS6YOOfLDnXHPw7KrW0Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createq_45f3c_mxVT_u7VX0NJLVFJDvgRCfgFP3F3kP2jlnDPUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(listWVhgPJaAOi9622DMsyi_GGN1YroR8hDCW94m1oniMsgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_93ZRu0Ptt7EqX_mAIPfPV04iNm7n_45tqt5L5wBKFIaRH9EMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_9333MCXBiLd4JGcsHjkzMf9TudxaozTobJN2xVOg5aFwEMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93tSMKt4vJLIX3ozxL0ifeegAw8glyNNeNeUhGpNKvltQMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93MQXkxqzfddEiiMIG60seP7pFU49z_oKjtF0rlHmdv2AMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_db7b5d36/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizations_45Bu1pIul6Ev_1NApJBc8e0omqRnoFg8vIPJL1PwqgBcMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexXb4jOOtObR6N3H0M_5E_IHYPyMTkJP8JgZPe10t86HIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsIekBKDiv_45x2LvQBb3lilvg5_d_Sc_QZ_zHqDptJuBEQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_db7b5d36/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencesFvOZPPs59p0IpyX_45zxfzDCa_Uuj0XNuZKC5iW2NYKmgMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: login20fRSwIZ5GupuHPtlQhBFyh4VQNI0YtPaPs41BxJKukMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93WzJMpMANVHHmC8nPKVpXsMgayQl2XqMXQBz_45bX7dmxQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutscbF6EevfwDEN_F16vpE_rpqQ_CEySY_45QhD_45GiKamCkMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_db7b5d36/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(list9yPBa3Z_45y7SgRufsAWkmBeW_45eUNXUH3yqoHqoxkasl4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_934pEi2vv7G_45ZRm0EpdNsw0_8zvjC55lZeFnNOJNCYbu8Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registerhoZxitNhnlLqGAEBOkgmBE1wCy8rmB_454ACergP2VKF8Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_936Xyr4IyB6PKJ8Jl8H_DJbF_45ZNqbZ0UB8iNFfQLrzhYMMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discordhBL6MvMnuMPj4ohkWYEuUaQjpNjS4TbUR07kLczlrboMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexcYZ_45mlXosbh6LZ92DyzV88dsk8T0m8gGhj4JTgdVHL4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentes02Lubxildw_45D_45L4E2Rsmf6lWhqh91vfroYQcmqxSu_45IMeta || {},
    component: () => import("/tmp/build_db7b5d36/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authNQVPY9dKTtnPqK3loGKlTnhlFIVe6voYqjNEQJ4G0L4Meta || {},
    component: () => import("/tmp/build_db7b5d36/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribeLGQu9ruRD04vSPEsTgrQ99UgfykVEROMf0vClUw69pMMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexNYxVfIwExDEJIqdCJUpNNKj83etVgRJ8d6hLhM_45w0IoMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexW3mdERJQzkmTpi29kB1vk3kvwAdQMG3bGeNGWKQpMTgMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93Ja_45NkKM67y8_459BRQMVpd4sXSHyRcp_452oloztd83nVQwMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: edit1XOGstdSUSGeFqtQrB_oEbqfRFNIFXvsrOwyyHTKfXIMeta?.name,
    path: "edit",
    meta: { ...(edit1XOGstdSUSGeFqtQrB_oEbqfRFNIFXvsrOwyyHTKfXIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexoL64mHSmX7OplBi2TB7dh2H6lzUG4lBpDSG7FzDlsHAMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesu_45WHKaw_jNil9wtq4iZYH5oBfAfetSCNoTJwjRgyIjQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(create9Ds_45ZPRMt5Y5hWbGAXC9rNzpIUbm54z6rzn3Vnlr8kUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(indexA07E8HxW8SGqPJbDDqe2Jkj9PIOdRNSvbMjR6t8NQVwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexJYM_45pv8g1CdrftAXX8_45OgMt17HiUfKTZiicWgGbLAHUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_db7b5d36/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stub4YlwUqQIT3ervUEL_s1LQYXSRQdGcU1ZFN9EY4jE0T0Meta?.name,
    path: "/sitemap.xml",
    component: component_45stub4YlwUqQIT3ervUEL_s1LQYXSRQdGcU1ZFN9EY4jE0T0
  }
]